import { ButtonGroup, IconButton, Stack, Text } from '@telescope/cassini-ui';
import { Facebook, TwitterX } from 'icons';

type ShareData = {
  content: {
    cta: string;
    twitter: {
      copy: string;
      link?: string;
      iconAccessibility?: string;
    };
    facebook: {
      copy: string;
      url?: string;
      iconAccessibility?: string;
    };
  };
  settings: {
    displayFacebook: boolean;
    displayTwitter: boolean;
  };
};

export const Share = ({ content, settings }: ShareData) => {
  if (!settings.displayFacebook && !settings.displayTwitter) return null;

  const twitterShare = () => {
    const { copy, link } = content.twitter;

    const url = new URL('https://twitter.com/intent/tweet');
    url.searchParams.append('text', copy);
    if (link) url.searchParams.append('url', link);

    window.open(url, '_blank', 'height=420,width=550');
  };

  const facebookShare = () => {
    const { copy, url: shareUrl = window.location.href } = content.facebook;

    const url = new URL('https://www.facebook.com/sharer/sharer.php');
    url.searchParams.append('u', shareUrl);
    if (copy) url.searchParams.append('quote', copy);

    window.open(url, 'popup', 'width=600, height=400, scrollbars=no');
  };

  return (
    <Stack alignItems="center" spacing={4}>
      {content.cta && <Text fontWeight="medium"> {content.cta} </Text>}
      <ButtonGroup variant={'link'} spacing={[2, 4]}>
        {settings.displayTwitter && (
          <IconButton
            minW="none"
            fontSize={{ base: '2xl', md: '4xl' }}
            data-share-method="twitter"
            aria-label={content.twitter.iconAccessibility || 'Share on Twitter'}
            icon={<TwitterX onClick={twitterShare} />}
          />
        )}
        {settings.displayFacebook && (
          <IconButton
            minW="none"
            fontSize={{ base: '2xl', md: '4xl' }}
            data-share-method="facebook"
            aria-label={content.facebook.iconAccessibility || 'Share on Facebook'}
            icon={<Facebook onClick={facebookShare} />}
          />
        )}
      </ButtonGroup>
    </Stack>
  );
};
